// Every locale bundled eagerly. Used by the widget and by tests; the webview loads only the active locale
// (see loadTranslations.ts).
import ar_sa from "../translations/ar-sa/translations.json";
import az from "../translations/az/translations.json";
import be from "../translations/be/translations.json";
import cs from "../translations/cs/translations.json";
import da from "../translations/da/translations.json";
import de from "../translations/de/translations.json";
import el from "../translations/el/translations.json";
import en_gb from "../translations/en-GB/translations.json";
import es from "../translations/es/translations.json";
import es_mx from "../translations/es-mx/translations.json";
import et from "../translations/et/translations.json";
import fi from "../translations/fi/translations.json";
import fr from "../translations/fr/translations.json";
import hr from "../translations/hr/translations.json";
import hu from "../translations/hu/translations.json";
import hy from "../translations/hy/translations.json";
import ka from "../translations/ka/translations.json";
import it from "../translations/it/translations.json";
import lt from "../translations/lt/translations.json";
import lv from "../translations/lv/translations.json";
import ne from "../translations/ne/translations.json";
import nl from "../translations/nl/translations.json";
import nl_be from "../translations/nl-be/translations.json";
import no from "../translations/no/translations.json";
import pl from "../translations/pl/translations.json";
import pt from "../translations/pt/translations.json";
import ro from "../translations/ro/translations.json";
import ru from "../translations/ru/translations.json";
import si from "../translations/si/translations.json";
import sk from "../translations/sk/translations.json";
import sr_latn from "../translations/sr-latn/translations.json";
import sv from "../translations/sv/translations.json";
import sw from "../translations/sw/translations.json";
import th from "../translations/th/translations.json";
import tr from "../translations/tr/translations.json";
import uk from "../translations/uk/translations.json";
import ur from "../translations/ur/translations.json";
import vi from "../translations/vi/translations.json";
import zh from "../translations/zh/translations.json";

const locales = {
    "ar-sa": ar_sa,
    az,
    be,
    cs,
    da,
    de,
    el,
    "en-gb": en_gb,
    es,
    "es-mx": es_mx,
    et,
    fi,
    fr,
    hr,
    hu,
    hy,
    ka,
    it,
    lt,
    lv,
    ne,
    nl,
    "nl-be": nl_be,
    no,
    pl,
    pt,
    ro,
    ru,
    si,
    sk,
    "sr-latn": sr_latn,
    sv,
    sw,
    th,
    tr,
    uk,
    ur,
    vi,
    zh,
};

export default locales;
